import { QuerySegment } from "./QuerySegment";
import { loadSegment } from "./QueryUtility";

export class QuerySpan extends QuerySegment {
  // Supported Field Types: text
  field?: string;
  distance?: number;
  ordered?: boolean;

  left?: QuerySegment;
  right?: QuerySegment;

  constructor(querySpan: any) {
    super(querySpan);
    this.fromJSON(querySpan);
    return this;
  }

  fromJSON(querySpan: any) {
    this.op = querySpan?.op;
    this.field = querySpan?.field;
    this.distance = querySpan?.distance;
    this.ordered = querySpan?.ordered
    this.left = loadSegment(querySpan?.left);
    this.right = loadSegment(querySpan?.right);
  }

  toAPIQuery() {
    let queryObj:any = {
      op: this.op
    }
    if (this.field) { queryObj.field = this.field; }
    if (this.distance) { queryObj.distance = this.distance; }
    if (this.ordered) { queryObj.ordered = this.ordered; }
    if (this.left) { queryObj.left = this.left.toAPIQuery(); }
    if (this.right) { queryObj.right = this.right.toAPIQuery(); }
    return queryObj;
  }
}
